module.exports = __webpack_public_path__ + "1793882494189/images/fa-brands-400.83e6c29.svg";